module.exports = __webpack_public_path__ + "media/dashboard/assets/images/chat-920840961f6cac28dafb9803001c3746.svg";